import React, { forwardRef } from "react";

export const PrintModal = forwardRef(
  ({ title,subtitle, head = [], body = [], foot = [] }, ref) => {
    return (
      <div ref={ref} className="print-area">
        {/* ✅ PRINT CSS INSIDE COMPONENT */}
        <style>
          {`
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
                color: #000;
                background: #fff;
              }

              /* Hide everything except print */
              body * {
                visibility: visible;
              }

              .print-area,
              .print-area * {
                visibility: visible;
              }

              .print-area {
  width: 100%;
  padding: 16px;
  margin-bottom: 20px;
  display: block;
}

              /* Title */
              .print-title {
                text-align: center;
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 50px;
              }

              
                 /* Sub Title */
              .print-subtitle {
                text-align: center;
                font-size: 12px;
                font-weight: bold;
                margin-bottom: 15px;
              }
                
                

              /* Table styles */
              table {
                width: 100%;
                border-collapse: collapse;
                font-size: 12px;
              }

              thead {
                background: #f0f0f0;
              }

              th,
              td {
                border: 1px solid #000;
                padding: 6px 8px;
                text-align: left;
              }

              th {
                font-weight: bold;
              }

              /* Right align amounts */
              .text-right {
                text-align: right;
              }

              /* Footer / totals */
              .print-footer {
                font-weight: bold;
                background: #f9f9f9;
              }

              /* Avoid row break */
              tr {
                page-break-inside: avoid;
              }
              .text-center {
  text-align: center;
}

              @page {
                size: A4;
                margin: 12mm;
              }
            }
          `}
        </style>

        {/* ✅ TITLE */}
        <div className="print-title">{title}</div>
              {/* ✅ SUBTITLE (DATE RANGE) */}
        {subtitle && (
          <div className="print-subtitle">{subtitle}</div>
        )}

        {/* ✅ TABLE */}
        <table>
          <thead>
            <tr>
              {head.map((h, i) => (
                <th key={i}>{h}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {body.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
               <td
  key={j}
  className={
    cell === null || typeof cell === "boolean"
      ? "text-center"
      : j >= 2
      ? "text-right"
      : ""
  }
>
  {cell === null ? "" : String(cell)}
</td>


                    
                ))}
              </tr>
            ))}
          </tbody>

          {foot.length > 0 && (
            <tfoot>
              <tr className="print-footer">
                {foot.map((f, i) => (
                  <td key={i}>{f}</td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    );
  }
);
